// export const BASE_URL = "http://13.203.142.166:8889/"; // Local API

export const MOBILE_SIZE = "768px";
// export const BASE_URL =
//   "zz";

// export const BASE_URL = "http://localhost:8889/"; // production
// export const PERMISSION_URL = "http://13.203.142.166:8899/"; // Local Permission API
// export const UPLOAD_IMAGE = "http://13.203.142.166:8899/file/upload";
// export const IMAGE_URL = "http://13.203.142.166:8899/file/download/";
// export const UPLOAD_IMAGE_BASE64 = "https://tivarax.in/api/upm/file/upload/base64";

// export const BASE_URL = "http://13.203.142.166:8889/"; // production
// export const PERMISSION_URL = "http://192.168.1.72:8899/"; // Local Permission API
// export const UPLOAD_IMAGE = "http://192.168.1.72:8899/file/upload";
// export const UPLOAD_IMAGE_BASE64 = "http://192.168.1.72:8899/file/upload/base64";
// export const IMAGE_URL = "http://192.168.1.72:8899/file/download/";

// Environment-driven URLs - use ONLY env files for preprod/prod switching
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const PERMISSION_URL = process.env.REACT_APP_PERMISSION_URL || process.env.REACT_APP_API_BASE_URL;
export const UPLOAD_IMAGE = process.env.REACT_APP_UPLOAD_IMAGE;
export const UPLOAD_IMAGE_BASE64 = process.env.REACT_APP_UPLOAD_IMAGE_BASE64 || "https://upm.tivarax.in/api/upm/file/upload/base64";
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
export const OSRM_BASE_URL = process.env.REACT_APP_OSRM_BASE_URL;

export const ENCRYPTION_KEY = "your-encryption-key";

// Location tracking configuration
export const LOCATION_CONFIG = {
  UPDATE_INTERVAL: 30000, // 30 seconds in milliseconds
  HIGH_ACCURACY: true,
  TIMEOUT: 5000,
  MAX_AGE: 0
};

// "email": "ankitvermaaa083@gmail.com",
// "password": "Tivarax@2023#"

export const ENDPOINTS = {
  // Base URL (for reference in handlers)
  baseUrl: BASE_URL,

  // Login API
  login: "api/v1/authenticate",
  updatePassword: "api/v1/user/update/password",

  // FCM Token API
  registerFCMToken: "api/v1/fcm/token",
  deleteFCMToken: "api/v1/fcm/token/", // Base URL for delete, token will be appended
  deactivateFCMToken: "api/v1/fcm/token/deactivate", // PATCH endpoint to deactivate token

  // OTP API
  otpGenerate: "otp/generate",
  otpValidate: "otp/validate",

  //get permission by role
  getPermissionByRole: "api/role-permission-mapping/get/roleId",

  // Dashboard APIs (Enhanced dashboard endpoints)
  // NOTE: These endpoints return `CustomResponse` with payload under `data`.
  getAllDashboardStats: "api/enhanced/dashboard/booking-stats",
  getAllTripStats: "api/enhanced/dashboard/trip-stats",
  getAllDashboardCustomers: "api/enhanced/dashboard/top-customers",
  getAllDashboardLastTrips: "api/enhanced/dashboard/booking-trends",
  getTripTrends: "api/enhanced/dashboard/trip-trends",
  getTripDistribution: "api/enhanced/dashboard/trip-distribution",
  getNoResponseCities: "api/enhanced/dashboard/no-response-cities",
  getCityFulfillmentRatio: "api/enhanced/dashboard/city-fulfillment-ratio",

  // Analytics APIs (Backend: `/api/analytics/*`)
  getTripAnalytics: "api/analytics/trip-analytics",
  getTripRevenueAnalytics: "api/analytics/revenue-analytics",
  getTripDriverAnalytics: "api/analytics/driver-performance",
  getVehicleUtilization: "api/analytics/vehicle-utilization",

  // ETS Trips API
  getETSTripById: "api/ets-trips/",
  etsTripsAll: "api/ets-trips/all",
  etsTripsAllV2: "api/ets-trips/v2/all",
  etsTripCounts: "api/ets-trips/counts",
  startTrip: "api/ets-trips/start",
  reachedLocation: "api/ets-trips/reached-location",
  verifyPickupOtp: 'api/ets-trips/verify-pickup-otp',
  verifyDropOtp: 'api/ets-trips/verify-drop-otp',
  startSendingLocation: "api/ets-trips/start/sending/location",
  skipEmployee: "api/ets-trips/skip-employee",
  endTrip: "api/ets-trips/end",
  dropEndTrip: "api/ets-trips/drop/end",
  etsTripsCreate: "api/ets-trips/create",
  etsTripsUpdate: "api/ets-trips/update",
  etsTripCancel: "api/ets-trips/cancel",
  exportTripsExcel: "api/ets-trips/export/excel",
  updatePaymentMethod: "api/ets-trips/payment-method",
  settlePayment: "api/ets-trips/settle",
  rejectSettlement: "api/ets-trips/reject-settlement",
  updateTripPenalty: "api/ets-trips/penalty/update",
  createTripPenalty: "api/ets-trips/penalty/create",
  getTripPenalty: "api/ets-trips/penalty",
  deleteTripPenalty: "api/ets-trips/penalty/delete",
  // Bookings API
  getAllBookings: "api/requests/all",
  addNewBooking: "api/requests/create",
  getBookingById: "api/requests",
  bookingUpdate: "api/requests/update",
  confirmBooking: "api/customers/approve",
  rejectBooking: "api/customers/reject",

  // Vendors API
  getAllVendors: "api/vendors/all",
  getVendorDropdownList: "api/vendors/dropdown-list",
  getVendorsById: "api/vendors",
  createVendor: "api/vendors/create",
  updateVendor: "api/vendors/update",
  batchSuspendVendors: "api/vendors/batch-suspend",
  batchUnsuspendVendors: "api/vendors/batch-unsuspend",
  batchDeactivateTemporaryVendors: "api/vendors/batch-deactivate-temporary",
  batchReactivateVendors: "api/vendors/batch-reactivate",
  batchDeactivatePermanentVendors: "api/vendors/batch-deactivate-permanent",
  verifyOTP: "",
  confirmVendor: "api/vendors/approve",
  rejectVendor: "api/vendors/reject",
  exportVendorsExcel: "api/vendors/export/excel",

  // Drivers API
  getAllDrivers: "api/drivers/all",
  getDriverDropdownList: "api/drivers/dropdown-list",
  getDriversById: "api/drivers",
  addDriver: "api/drivers/create",
  updateDriver: "api/drivers/update",
  confirmDriver: "api/drivers/approve",
  rejectDriver: "api/drivers/reject",
  getDriverLocation: "api/locations/trip",
  getTripLocation: "api/locations/trip",
  updateDriverLocation: "api/locations/trip/update",

  // Vehicles API
  fetchAllVehicles: "api/vehicles/all",
  getVehicleDropdownList: "api/vehicles/dropdown-list",
  addVehicles: "api/vehicles/create",
  updateVehicle: "api/vehicles/update",
  getVehicleById: "api/vehicles",
  confirmVehicle: "api/vehicles/approve",
  rejectVehicle: "api/vehicles/reject",

  // Customer API
  fetchAllCustomers: "api/customers/all",
  addCustomer: "api/customers/create",
  updateCustomer: "api/customers/update",
  getAllCustomer: "api/customers/all",
  getCustomerById: "api/customers",
  confirmCustomer: "api/customers/approve",
  rejectCustomer: "api/customers/reject",

  // team Members
  getAllTeamMembers: "api/teamMembers/all",
  addTeamMember: "api/teamMembers/create",
  updateTeamMember: "api/teamMembers/update",
  teamMemberById: "api/teamMembers",
  deactivateTeamMember: "api/teamMembers/deactivate",

  // Profile API
  updateUser: "api/v1/user/update",
  changePassword: "api/v1/user/update/password",

  //  Extra API
  fetchAllCities: "cities/all",
  fetchAllStates: "",
  confirmRequest: "api/requests/confirm",
  tripCancel: "api/requests/cancel",
  tripReject: "api/requests/reject",
  forgotPassword: "api/v1/user/forgot-password",
  resetPassword: "api/v1/user/reset-password",

  // PUBLIC REGISTRATION (no auth)
  registerDriver: "api/public/register/driver",
  registerVendor: "api/public/register/vendor",
  validateReferral: "api/public/referral/validate",

  // Referral lead management APIs
  createReferralLead: "api/referral-leads",
  updateReferralLead: "api/referral-leads",
  getReferralLeadById: "api/referral-leads",
  getReferralLeadByCode: "api/referral-leads/by-code",
  getAllReferralLeads: "api/referral-leads/all",
  deactivateReferralLead: "api/referral-leads",

  // Onboarding profile completion APIs
  completeVendorProfile: "api/vendors/complete-profile",
  completeDriverProfile: "api/drivers/complete-profile",
  getVendorProfileStatus: "api/vendors",
  getDriverProfileStatus: "api/drivers",

  // STATES API
  fetchNextState: "api/permission-state-role-mapping/get/all",

  // Route endpoints
  getAllRoutes: 'api/routes/all',
  getAllRouteIds: 'api/routes/ids', // Get only route IDs matching filters
  addRoute: '/api/routes/create',
  updateRoute: 'api/routes/update',
  deleteRoute: '/api/routes/delete',
  getRouteById: 'api/routes',
   toggleBulkRouteStatus: 'api/routes/status',
  toggleRouteStatus: 'api/routes/toggle-status',
  deleteRouteStatus:"/api/routes/delete",
  deleteAllRoutes: "/api/routes/soft-delete",
  adjustBaseFare: '/api/routes/adjust-base-fare', // Adjust base fare for routes by percentage
  updateRoutePrices: 'api/routes/update-prices', // For bulk price updates in Route Configuration
  importRoutes: 'api/routes/import-excel', // For importing routes from Excel
  exportRoutesExcel: 'api/routes/export/excel', // For exporting routes to Excel

  // Event Configuration API
  createEventConfig: 'api/event-configs/create',
  updateEventConfig: 'api/event-configs/update',
  getEventConfigById: 'api/event-configs', // GET /api/event-configs/{id}
  getAllEventConfigs: 'api/event-configs/all',
  deleteEventConfig: 'api/event-configs/delete', // DELETE /api/event-configs/delete/{id}
  deactivateEventConfig: 'api/event-configs/deactivate', // POST /api/event-configs/deactivate/{id}
  activateEventConfig: 'api/event-configs/activate', // POST /api/event-configs/activate/{id}


  // generate excel
  generateExcel: "api/reports/generate",

  getAllEmployees: "api/employees/all",
  createEmployee: "api/employees/create",
  updateEmployee: "api/employees/update",
  deleteEmployee: "api/employees/delete",
  getEmployeeById: "api/employees",

  // File upload endpoints
  UPLOAD_IMAGE: UPLOAD_IMAGE,
  UPLOAD_IMAGE_BASE64: UPLOAD_IMAGE_BASE64,

  checkGeofence: 'api/ets-trips/destination/check-geofence',
  sourceCheckGeofence: 'api/ets-trips/source/check-geofence',

  // Geofence Price Config API
  getAllGeofencePriceConfigs: 'api/geofence-price-configs/all',
  createGeofencePriceConfig: 'api/geofence-price-configs/create',
  updateGeofencePriceConfig: 'api/geofence-price-configs/update',
  getGeofencePriceConfigById: 'api/geofence-price-configs',
  deleteGeofencePriceConfig: 'api/geofence-price-configs/delete',
  getGeofencePriceConfigByLocation: 'api/geofence-price-configs/by-location',

  // Dynamic Routes API
  getAllDynamicRoutes: 'api/dynamic-routes/all',
  createDynamicRoute: 'api/dynamic-routes/create',
  updateDynamicRoute: 'api/dynamic-routes/update',
  getDynamicRouteById: 'api/dynamic-routes',
  deleteDynamicRoute: 'api/dynamic-routes/delete',
  toggleDynamicRouteStatus: 'api/dynamic-routes/toggle-status',
  toggleDynamicRouteSpecific: 'api/dynamic-routes/toggle-specific',
  calculateDynamicFare: 'api/dynamic-routes/calculate-fare',
  generateDefaultSlabs: 'api/dynamic-routes/generate-default-slabs',
  generateDefaultForCity: 'api/dynamic-routes/generate-default-for-city',
  adjustDynamicRouteRates: 'api/dynamic-routes/adjust-rates',
  getDynamicRouteRateAdjustments: 'api/dynamic-routes', // GET /api/dynamic-routes/{id}/rate-adjustments
  getDynamicRouteAuditTrail: 'api/dynamic-routes', // GET /api/dynamic-routes/{id}/audit-trail

  // SLA Penalty Dashboard API
  getSlaPenalties: 'api/dashboard/sla-penalties',
  getSlaPenaltiesByType: 'api/dashboard/sla-penalties/by-type',
  getSlaPenaltyStats: 'api/dashboard/sla-penalty-stats',

  // Vendor Hierarchy API
  onboardVendorAdmin: 'api/vendors/onboard-admin',

  // Search API Debugger
  mmtSearch: 'api/search-debugger/partnersearch',
  // Look up a logged partner search by searchId (append /{searchId})
  searchDetails: 'api/search-debugger',

  // Tutorial Videos
  tutorialVideosAll: "api/tutorial-videos/all",
  tutorialVideosCreate: "api/tutorial-videos/create",
  tutorialVideosUpdate: "api/tutorial-videos/update",
  tutorialVideosDelete: "api/tutorial-videos/delete/",
  tutorialVideosByCategory: "api/tutorial-videos/category/",

  // Support Query
  submitSupportQuery: "api/public/support-query/submit",

  // Legal Documents & Consent API
  getAllLegalDocuments: "api/public/legal/documents",
  getLegalDocsByAudience: "api/public/legal/documents/audience",
  getLegalDocBySlug: "api/public/legal",
  recordLegalAcceptance: "legal/acceptances",
  getPendingLegalDocs: "legal/pending",
  getMyLegalAcceptances: "legal/acceptances/me",

  // Trip Review & Rating APIs
  getTripReview: "api/reviews/trip",
  getVendorReviewSummary: "api/reviews/vendor",
  getAllVendorRatingsSummary: "api/reviews/vendors/summary",

  // Super Vendor Toggle API
  toggleSuperVendor: "api/vendors",
  toggleSuperVendorById: (id) => `api/vendors/${id}/toggle-super-vendor`,

  // Vendor Broadcast & Announcement APIs
  getActiveAnnouncements: "api/v1/announcements/active",
  broadcastAnnouncement: "api/v1/announcements/broadcast",
  deactivateAnnouncement: "api/v1/announcements",
};
